import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const quizApiService = createApi({
  reducerPath: "quizApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createQuiz: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `quiz-response/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getQuiz: builder.mutation({
      query: ({ quizId, params }) => {
        let query = queryParams(params);
        return {
          url: `quiz-response/get/${quizId}${query}`,
          method: "GET",
        };
      },
    }),
    getQuizHistory: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `quiz-response/quiz/history${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    updateQuiz: builder.mutation({
      query: ({ quizId, payload, params }) => {
        let query = queryParams(params);
        return {
          url: `quiz-response/quiz/update/${quizId}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateQuizMutation,
  useGetQuizMutation,
  useGetQuizHistoryQuery,
  useUpdateQuizMutation,
} = quizApiService;
